import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as api from '../../../api';
import { ModalContainer } from '../../../components/ModalContainer';
import { AppointmentActionView } from '../AppointmentActionView';

import styles from './index.module.css';

interface AppointmentActionButtonProps {
  appointment: api.NotificationIntent.Appointment;
  encounterId: string;
  actionModalOpen: boolean;
  setActionModalOpen: (val: boolean) => void;
  className?: string;
  cancelOnly?: boolean;
  pending?: boolean;
  onCancelAppointment?: () => void;
  onRescheduleAppointment?: () => void;
  getAppointments: () => Promise<void>;
  practicePhoneNumber?: string;
  timezone: string;
}

export const AppointmentActionButton: React.FC<
  AppointmentActionButtonProps
> = ({
  appointment,
  encounterId,
  actionModalOpen,
  setActionModalOpen,
  className,
  cancelOnly,
  onCancelAppointment,
  pending,
  practicePhoneNumber,
  timezone,
  getAppointments,
}) => {
  const { t } = useTranslation();
  const [rescheduling, setRescheduling] = useState<boolean>(false);

  return (
    <ModalContainer
      isOpen={actionModalOpen}
      contentClassName={styles.RescheduleModalContainer}
      childrenContainerClassName={styles.RescheduleListContainer}
      onModalClose={() => setActionModalOpen(false)}
      topLabel={t('Modify Appointment')}
    >
      <AppointmentActionView
        appointment={appointment}
        rescheduleIdentifier={{ existingEncounterId: encounterId }}
        timezone={timezone}
        className={className}
        pending={pending || rescheduling}
        onCancelAppointment={onCancelAppointment}
        setRescheduling={setRescheduling}
        onRescheduled={() => {
          setActionModalOpen(false);
          getAppointments();
          setRescheduling(false);
        }}
        cancelOnly={cancelOnly}
        practicePhoneNumber={practicePhoneNumber}
      />
    </ModalContainer>
  );
};
